import { useEffect, useState } from "react";
import { api, formatTRY } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { Search, UserRound, ChevronDown, ChevronUp, HeartHandshake } from "lucide-react";

export const CustomerHistory = ({ refreshKey }) => {
  const [q, setQ] = useState("");
  const [customers, setCustomers] = useState([]);
  const [open, setOpen] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => { api.get("/customers").then((r) => setCustomers(r.data)).catch(() => {}); }, [refreshKey]);

  const toggle = async (name) => {
    if (open === name) return setOpen(null);
    setOpen(name); setDetail(null);
    const r = await api.get("/customers/sales", { params: { name } });
    setDetail(r.data);
  };

  const ql = q.trim().toLowerCase();
  const list = customers.filter((c) => !ql || c.name.toLowerCase().includes(ql)).slice(0, 30);

  return (
    <div className="rounded-xl border border-border bg-card p-5" data-testid="customer-history">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="flex items-center gap-2 font-heading text-lg font-semibold"><UserRound className="h-5 w-5" /> Müşteri Geçmişi</h3>
        <div className="relative w-64">
          <Search className="pointer-events-none absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input placeholder="Müşteri ara…" value={q} onChange={(e) => setQ(e.target.value)} className="h-9 pl-8" data-testid="customer-search" />
        </div>
      </div>
      <div className="mt-4 space-y-2" data-testid="customer-list">
        {list.length === 0 && <p className="text-sm text-muted-foreground">{customers.length === 0 ? "Henüz müşteri adı girilmiş satış yok" : "Eşleşen müşteri yok"}</p>}
        {list.map((c) => (
          <div key={c.name} className="rounded-lg bg-secondary/40" data-testid={`customer-row-${c.name}`}>
            <button type="button" className="flex w-full items-center justify-between px-3 py-2 text-left" onClick={() => toggle(c.name)} data-testid={`customer-toggle-${c.name}`}>
              <div>
                <p className="flex items-center gap-1.5 text-sm font-semibold">{c.club_member_id && <HeartHandshake className="h-3.5 w-3.5 text-primary" />}{c.name}</p>
                <p className="text-xs text-muted-foreground">{c.sales_count} satış · {c.items} ürün{c.last_at ? ` · son: ${new Date(c.last_at).toLocaleDateString("tr-TR", { timeZone: "Europe/Istanbul" })}` : ""}</p>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-heading text-lg font-extrabold text-primary" data-testid={`customer-total-${c.name}`}>{formatTRY(c.total_spent)}</span>
                {open === c.name ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
              </div>
            </button>
            {open === c.name && (
              <div className="border-t border-border/60 px-3 py-2 text-xs" data-testid={`customer-detail-${c.name}`}>
                {!detail && <p className="text-muted-foreground">Yükleniyor…</p>}
                {detail?.sales.map((s) => (
                  <div key={s.id} className="flex items-start justify-between py-1">
                    <div>
                      <p className="text-muted-foreground">{new Date(s.created_at).toLocaleString("tr-TR", { timeZone: "Europe/Istanbul" })} · {s.payment_type}{s.discount_amount > 0 ? ` · indirim −${formatTRY(s.discount_amount)}` : ""}</p>
                      <p>{s.items.map((i) => `${i.product_name} x${i.quantity}`).join(", ")}</p>
                    </div>
                    <span className="font-mono font-semibold">{formatTRY(s.total)}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
